import { BaseResource } from "utils/ApiUtils";

class ProjectDetails extends BaseResource {
  constructor(args, attr = ProjectDetails.attributes) {
    super(args, attr)
  }

  static columns = [
    { title: "ProjectName", field: "ProjectName" },
    { title: "ProjNumber", field: "ProjNumber" },
    { title: "TaskNumber", field: "TaskNumber" },
    { title: "ProjectTypeId", field: "ProjectTypeId" },
    { title: "PriorityId", field: "PriorityId" },
    { title: "ProjectPhaseId", field: "ProjectPhaseId" },
    { title: "ProjectStatusId", field: "ProjectStatusId" },
    { title: "Description", field: "Description" },
    { title: "EstStartDate", field: "EstStartDate" ,  type: "date" },
    { title: "EstCompDate", field: "EstCompDate" ,  type: "date" },
    { title: "ActualStartDate", field: "ActualStartDate" ,  type: "date" },
    { title: "ActualCompDate", field: "ActualCompDate" ,  type: "date"},
    { title: "Address", field: "Address" },
    { title: "City", field: "City" },
    { title: "StateId", field: "StateId" },
    { title: "Zip", field: "Zip" },
    { title: "CrossStreet", field: "CrossStreet" },
    { title: "Ward", field: "Ward" },
    { title: "Organization Name", field: "OrgProjectName" },
    { title: "Organization Id", field: "OrganizationId"},
    { title: "Internal Project #", field: "OrgProjectNumber" },
    { title: "Project ID", field: "ProjectId"},
    { title: "UserGroupId", field: "UserGroupId"},
  ]

  static attributes = ProjectDetails.columns.map(r => r.field);
  static expand = [];

}

export default ProjectDetails;
